
define('text!presentation/release/views/release.html',[],function () { return '<nav class="main-navigation">Hello</nav>\n';});

